import { DefaultLoader } from 'components/Loader';
import { MenteeStatusValues } from 'enums/MenteeStatus';
import { FC, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { mutate } from 'swr';
import privateAPI from 'utils/privateAxiosInstance';

export const ChooseMentorContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
`;

type Props = {
  menteeId: number;
  mentorId: number;
  redirect: string;
};
const ChooseMentorComponent: FC<Props> = ({
  menteeId,
  mentorId,
  redirect,
  children,
  ...props
}) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);
  const handleClick = async () => {
    setLoading(true);
    privateAPI
      .patch(`/user/status/${menteeId}`, {
        menteeStatus: 'ELIGIBLE' as MenteeStatusValues,
      })
      .then(() => {
        mutate(`/user/${menteeId}`);
        mutate(`/mentorship/mentee/${menteeId}`);
        mutate(`/mentorship/mentee/${menteeId}/ongoing`);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(async () => {
        return await privateAPI
          .post(`/mentorship`, {
            menteeId: menteeId,
            mentorId: mentorId,
          })
          .then(() => {
            navigate(redirect);
            mutate(`/mentorship/mentee/${menteeId}/ongoing`);
            mutate(`/mentorship/mentor/${mentorId}/ongoing`);
          })
          .catch((err) => {
            console.log(err);
            setLoading(false);
          });
      });
  };
  return (
    <div onClick={handleClick} {...props}>
      {loading ? <DefaultLoader /> : children}
    </div>
  );
};

export const ChooseMentor = styled(ChooseMentorComponent)`
  font-size: 0.9rem;
  font-weight: 500;
  color: var(--primary-700);
  text-align: center;
  cursor: pointer;
`;

export const CurrentMentor = styled.div`
  font-size: 0.9rem;
  font-weight: 500;
  color: black;
  text-align: center;
`;
